import React from 'react';
import classnames from 'classnames';
import _get from 'lodash/get';

export default function DetectionItem({
  categoryKey,
  detectionMapping,
  activeDetection,
  setActiveDetection,
  isLandscape,
  scoreFormat,
  activeLang,
}) {
  return (
    <div
      className={classnames({
        'skincaredetectionpreview-detections__detection': true,
        'skincaredetectionpreview-detections__detection--landscape': isLandscape,
      })}
    >
      <b
        style={{
          border: `3px solid ${_get(
            detectionMapping,
            `${categoryKey}.color`,
            '#ccc'
          )}`,
          backgroundColor:
            activeDetection === categoryKey
              ? _get(detectionMapping, `${categoryKey}.color`, '#ccc')
              : 'rgba(255,255,255,0.3)',
          textShadow: '#000000B2 0 1.42px 1.42px',
        }}
        className={classnames({
          'cursor-pointer': true,
          'skincaredetectionpreview-detections__detection-circle': true,
          'skincaredetectionpreview-detections__detection-circle--landscape': isLandscape,
        })}
        onClick={() => setActiveDetection(categoryKey)}
      >
        {scoreFormat === 'percentile'
          ? detectionMapping[categoryKey].score
          : (detectionMapping[categoryKey].score / 10).toFixed(1)}
      </b>
      <div
        className={classnames({
          'skincaredetectionpreview-detections__detection-name': true,
          'skincaredetectionpreview-detections__detection-name--landscape': isLandscape,
        })}
      >
        {_get(
          detectionMapping,
          `${categoryKey}.labelI18n.${activeLang}`,
          detectionMapping[categoryKey].label
        )}
      </div>
    </div>
  );
}
